import React, { ChangeEvent, useState } from 'react'
import { isEmpty, without } from 'lodash'
import { t, Trans } from '@lingui/macro'
import { OrganisationRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useAllGroupsQuery } from 'front-end/src/graphql/commonQueries/allGroups.codegen'
import {
  Box,
  Checkbox,
  MenuBulkAction,
  HStack,
  MenuItem
} from 'front-end/src/components'
import { useManageUsersPageContext } from '../ManageUsersPageContext'
import { brandColors } from 'front-end/../shared/basicPalette'
import { radii } from 'front-end/src/components/chakraThemeExtension'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'
import { AddUsersToGroupsModal } from 'front-end/src/pages/manage-users-page/components/AddUsersToGroupsModal'

export const UsersBatchActions = () => {
  const { session } = usePublicApiSession()
  const {
    toggleAllUsersSelection,
    selectedUserIds,
    onRoleChange,
    onRemoveUser,
    fetchUsers
  } = useManageUsersPageContext()
  const [state, setState] = useState({
    showAddGroupModal: false
  })

  const { data } = useAllGroupsQuery({
    fetchPolicy: 'cache-first'
  })
  const onCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked
    toggleAllUsersSelection && toggleAllUsersSelection({ value })
  }

  const toggleAddGroupModal = (value) => setState({ showAddGroupModal: value })

  const isAnySelected = () => {
    return !isEmpty(selectedUserIds)
  }

  const getSelectedIds = (includeSelf = false): number[] => {
    if (includeSelf) {
      return selectedUserIds
    }
    return without(selectedUserIds, session?.user.id as number)
  }

  const setRole = (role: OrganisationRoleEnum) => {
    const target = getSelectedIds()
    onRoleChange && onRoleChange({ target, role })
  }

  const { showAddGroupModal } = state

  return (
    <>
      {showAddGroupModal && (
        <AddUsersToGroupsModal
          target={getSelectedIds(true)}
          show
          excludeExistingGroups={false}
          onHide={() => toggleAddGroupModal(false)}
          onCompleted={fetchUsers}
          groups={data?.groups}
        />
      )}
      <HStack spacing="16px">
        <Box>
          <Checkbox
            verticalAlign="text-bottom"
            borderRadius={radii.sm}
            backgroundColor={brandColors.white}
            isChecked={isAnySelected()}
            onChange={onCheckboxChange}
          />
        </Box>
        <MenuBulkAction isDisabled={!isAnySelected()}>
          <MenuItem onClick={() => toggleAddGroupModal(true)}>
            <Trans>Add to group</Trans>
          </MenuItem>
          <MenuItem onClick={() => setRole(OrganisationRoleEnum.ADMIN)}>
            <Trans>Change role to Full administrator</Trans>
          </MenuItem>
          <MenuItem onClick={() => setRole(OrganisationRoleEnum.STUDENT)}>
            <Trans>Change role to General user</Trans>
          </MenuItem>
          <MenuItem
            onClick={() => {
              const target = getSelectedIds()

              const confirmed = confirm(
                t`Are you sure you want to remove ${target.length} users?`
              )
              confirmed && onRemoveUser && onRemoveUser({ target })
            }}
          >
            <Trans>Archive</Trans>
          </MenuItem>
        </MenuBulkAction>
      </HStack>
    </>
  )
}
